import { render } from "./UserDashboard.vue?vue&type=template&id=2f4857e6"
import script from "./UserDashboard.vue?vue&type=script&lang=js"
export * from "./UserDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script